import {Redirect} from 'react-router-dom';
import connected from '../connected';

export function DefaultPage() {
  return <Redirect to="/properties/search"/>;
}

export default connected(DefaultPage);